import React from 'react';

interface Props {
	className?: string;
	children: React.ReactNode;
}

export function Feilboks(props: Props) {
	const { className, children, ...rest } = props;

	return (
		<div {...rest} className={`beskjedboks beskjedboks-feil ${className}`}>
			{/* Det er en indre div fordi ellers ødelegger ikon-stilingen for boks-stilingen */}
			<div className={'er-feil'}>{children}</div>
		</div>
	);
}
